<template>
    <b-modal
        v-if="category"
        :id="'portfolio-edit-add-existing-assignment-modal-' + category.id"
        :ref="'portfolio-edit-add-existing-assignment-modal-' + category.id"
        :title="$t('portfolio.add_existing_exercises')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        @ok="onOk"
        :ok-disabled="!selectedAssignment"
        cancel-variant="outline-primary"
        ok-variant="primary"
        modal-class="apprentice-default-modal">
        <!--        group-->
        <div
            class="group"
            v-if="!loadingGroups">
            <b-form-group
                :label="$t('portfolio.select_group')"
                label-for="portfolio-group-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="portfolio-group-select"
                    v-model="selectedGroup"
                    v-if="groupOptions.length"
                    :options="groupOptions"
                    value-field="id"
                    text-field="name">
                </b-form-select>
            </b-form-group>
        </div>

        <!--        category-->
        <div
            class="category"
            v-if="selectedGroup && !loadingGroups && !loadingCategories">
            <b-form-group
                :label="$t('portfolio.select_category')"
                label-for="portfolio-category-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="portfolio-category-select"
                    v-model="selectedCategory"
                    v-if="categoryOptions.length"
                    :options="categoryOptions"
                    value-field="id"
                    text-field="name">
                </b-form-select>
            </b-form-group>
        </div>

        <!--        assignment-->
        <div
            class="assignment"
            v-if="selectedCategory && !loadingGroups && !loadingCategories && !loadingAssignments">
            <b-form-group
                :label="$t('portfolio.select_exercise')"
                label-for="portfolio-assignment-select">
                <b-form-select
                    class="apprentice-primary-select"
                    id="portfolio-assignment-select"
                    v-model="selectedAssignment"
                    v-if="assignmentOptions.length"
                    :options="assignmentOptions"
                    value-field="id"
                    text-field="name">
                </b-form-select>
            </b-form-group>
        </div>

        <div
            class="col-12"
            v-if="!loadingGroups && !loadingCategories && !loadingAssignments && !selectedAssignment">
            <span class="invalid-feedback d-block">
                <strong>
                    {{ $t('portfolio.this_category_has_no_assignments') }}
                </strong>
            </span>
        </div>

        <div
            class="loading"
            v-if="loadingGroups || loadingCategories || loadingAssignments">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-portfolio-edit-add-existing-assignment-component',
    props: ['category', 'portfolioIn', 'groupId'],
    data() {
        return {
            selectedGroup: null,
            selectedCategory: null,
            selectedAssignment: null,
            loadingGroups: false,
            loadingCategories: false,
            loadingAssignments: false,
            groupOptions: [],
            categoryOptions: [],
            assignmentOptions: [],
            portfolio: this.portfolioIn,
            errorMessage: '',
        };
    },
    watch: {
        selectedGroup(value) {
            if (!value) {
                return;
            }
            this.selectedCategory = null;
            this.selectedAssignment = null;
            this.loadingCategories = true;
            this.axios.get(this.routes.portfolioGroupCategories(value)).then(
                (response) => {
                    this.categoryOptions = response.data;
                    this.selectedCategory = this.categoryOptions.length && this.categoryOptions[0].id;
                    this.loadingCategories = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        selectedCategory(value) {
            if (!value) {
                return;
            }
            this.selectedAssignment = null;
            this.loadingAssignments = true;
            this.axios.get(this.routes.portfolioCategoryAssignments(value)).then(
                (response) => {
                    this.assignmentOptions = response.data;
                    this.selectedAssignment = this.assignmentOptions.length && this.assignmentOptions[0].id;
                    this.loadingAssignments = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        selectedAssignment(value) {
            if (!value) {
                return;
            }
            for (const assignment of this.assignmentOptions) {
                if (assignment.id === value) {
                    this.name = assignment.name;
                }
            }
        },
    },

    methods: {
        onOk(bvModalEvent) {
            if (!this.selectedAssignment) {
                bvModalEvent.preventDefault();
                this.errorMessage = this.$t('Er is geen opdracht geselecteerd.');
                return false;
            }

            const values = {
                name: this.name,
                category_id: this.category.id,
                copy: this.existingOption,
                assignment_id: this.selectedAssignment,
            };

            this.createAssignment(values);
        },

        createAssignment(values) {
            this.alert.saving(
                this.$t('portfolio.add_exercise'),
                this.$t('portfolio.exercise_will_be_added_please_wait_a_moment'),
            );

            let order = 0;
            for (const category of this.portfolio.categories) {
                if (category.id === values.category_id) {
                    order = category.assignments.length + 1;
                    break;
                }
            }

            const data = {
                name: values.name,
                category_id: values.category_id,
                order: order,
                assignment_id: values.assignment_id,
            };

            this.axios.post(this.routes.portfolioCopyAssignment(), data).then(
                (response) => {
                    this.alert.success();
                    window.location.href = this.routes.assignmentEdit(
                        response.data.id,
                        this.groupId,
                    );
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        // onShow() {
        //     this.selectedAssignment = null;
        // }
    },

    created() {
        this.axios.get(this.routes.portfolioGroupList()).then(
            (response) => {
                this.groupOptions = response.data;
                this.selectedGroup = this.groupOptions.length ? this.groupOptions[0].id : null;
                this.loadingGroups = false;
            },
            (error) => {
                this.alert.ajaxError(error);
            },
        );
    },

    computed: {
        invalidFeedback() {
            if (!this.groupOptions.length) {
                return this.$t('portfolio.no_groups_found');
            }

            if (!this.categoryOptions.length) {
                return this.$t('portfolio.chosen_group_has_no_categories');
            }

            if (!this.assignmentOptions.length) {
                return this.$t('portfolio.chosen_category_has_no_exercise');
            }

            return null;
        },
    },
};
</script>

<style scoped lang="scss">
.loading {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    color: $primary;
    padding-top: map-get($grid-gutter-spacing, 'twenty-one');
    padding-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.form-group {
    .apprentice-primary-select {
        margin-bottom: 0;
    }
}
</style>
